import WishlistCount from './WishlistCount.vue';
import WishlistHeart from './WishlistHeart.vue';
import WishlistPage from './WishlistPage.vue';
import RegionDirectory from './RegionDirectory.vue';
import EventDates from './EventDates.vue';
import ShareBundle from './ShareBundle.vue';

export default {
	WishlistCount,
	WishlistHeart,
	WishlistPage,
	RegionDirectory,
	EventDates,
	ShareBundle
}
